module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card-text', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [(_vm.error) ? _c('v-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "12",
      "sm": "10",
      "offset-sm": "1"
    }
  }, [(_vm.error.code === 'auth/user-not-found') ? _c('v-alert', {
    staticClass: "warning",
    attrs: {
      "dismissible": ""
    },
    on: {
      "dismissed": _vm.onDismissed
    }
  }, [_vm._v("\n        Die angegebene Mailadresse ist falsch oder nicht vergeben. Solltest Du Dich noch nicht registriert haben, kannst Du das "), _c('a', {
    attrs: {
      "href": "/registrieren"
    }
  }, [_vm._v("HIER")]), _vm._v(" machen.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.error.code === 'auth/wrong-password') ? _c('v-alert', {
    staticClass: "warning",
    attrs: {
      "dismissible": ""
    },
    on: {
      "dismissed": _vm.onDismissed
    }
  }, [_vm._v("\n        Das Passwort ist falsch.\n      ")]) : _vm._e(), _vm._v(" "), ((_vm.error.code !== 'auth/user-not-found') && (_vm.error.code !== 'auth/wrong-password')) ? _c('v-alert', {
    staticClass: "warning",
    attrs: {
      "dismissible": ""
    },
    on: {
      "dismissed": _vm.onDismissed
    }
  }, [_vm._v("\n        Bei der Anmeldung ist ein Fehler aufgetreten. Fehlercode: " + _vm._s(_vm.error.code) + " | " + _vm._s(_vm.error.message) + "\n      ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10",
      "offset-sm": "1"
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "email",
      "loading": _vm.loading,
      "append-icon": _vm.checkMailValue.status === null ? '' : (_vm.checkMailValue.status ? 'check' : 'close'),
      "hint": !_vm.checkMailValue.status ? _vm.checkMailValue.message : '',
      "persistent-hint": "",
      "label": "Mail",
      "id": "email",
      "type": "email",
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": function($event) {
        return _vm.checkMail()
      }
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10",
      "offset-sm": "1"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "name": "password",
      "label": "Passwort",
      "id": "password",
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10",
      "offset-sm": "1"
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "block": "",
      "disabled": !this.password || (this.checkMailValue.status === false) || (this.checkMailValue.status === null),
      "loading": _vm.$vars.loading
    },
    on: {
      "click": function($event) {
        return _vm.onSignin()
      }
    }
  }, [_vm._v("\n        Anmelden\n      ")])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "12",
      "sm": "10",
      "offset-sm": "1"
    }
  }, [_c('v-btn', {
    staticClass: "caption",
    attrs: {
      "block": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.goToRegistrierung()
      }
    }
  }, [_vm._v("\n        Registrieren\n      ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "caption",
    attrs: {
      "block": "",
      "text": "",
      "to": "/passwortvergessen"
    },
    on: {
      "click": function($event) {
        return _vm.onDismissed()
      }
    }
  }, [_vm._v("\n        Passwort vergessen?\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a0499ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/SigninForm.vue
// module id = 760
// module chunks = 15